__turbopack_context__.v({
  "B2BLoadProfiles": "eOcL3G_B2BLoadProfiles",
  "Card": "eOcL3G_Card",
  "Headline": "eOcL3G_Headline",
});
